export default {
}



// WEBPACK FOOTER //
// src/store/chrome/runtime/getters.js